import * as React from "react";
import { Datagrid, TextField } from "react-admin";
import { DefaultCreatedDateSort, DefaultPerPageSize } from "../../../Constants/Constant";
import { EnumField } from "../../../Components/EnumField";
import { useVerifyPermission } from "@airborne/react-admin";
import PoolList from "../../../Components/PoolListComponent/PoolListComponent";

const MailSchemaList = props => {
  useVerifyPermission("mailschemas", "read");
  return (
    <PoolList
      {...props}
      title={"Mail Schema"}
      sort={DefaultCreatedDateSort}
      perPage={DefaultPerPageSize}
      bulkActionButtons={false}
    >
      <Datagrid {...props} optimized rowClick="edit">
        <TextField source="subject" label="Subject" />
        <EnumField label={"Schema"} enumName={"StepType"} source={"stepType"} />
      </Datagrid>
    </PoolList>
  );
};

export default MailSchemaList;
